import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToolbarService } from 'src/app/core/services/toolbar.service';
import { AppConfig } from '../../../core/services/app-config.service';
import { HandsetService } from '../../../core/services/handset.service';

interface LiabilityButton {
  title: string;
  subtitle: string;
  icon: string;
  function: () => void;
  disabled?: boolean;
  bgColor?: string;
  bgHoverColor?: string;
}

@Component({
  standalone: false,
  selector: 'app-add-liability',
  templateUrl: './add-liability.component.html',
  styleUrls: ['./add-liability.component.scss'],
})
export class AddLiabilityComponent implements OnInit {

  buttons: LiabilityButton[] = [
    {
      title: 'Pobieraj automatycznie',
      subtitle: 'Pobieraj rachunki automatycznie',
      icon: 'cloud_download',
      function: () => this.onGoToEbok(),
      bgColor: '#DFD0EB',
      bgHoverColor: '#BFABD0'
    },
    {
      title: 'Dodaj zdjęcie, plik',
      subtitle: 'Odczytamy dane wydatku z pliku i poprosimy Cię o potwierdzenie',
      icon: 'add_a_photo',
      function: () => this.onGoToScan(),
      bgColor: '#EDE4F4',
      bgHoverColor: '#DFD0EB'
    },
    {
      title: 'Wyśljj na e-mail',
      subtitle: 'Odczytamy dane wydatku z pliku i poprosimy Cię o potwierdzenie',
      icon: 'alternate_email',
      function: () => this.onGotoMailSending(),
      bgColor: '#FAF8FC',
      bgHoverColor: '#EDE4F4'
    },
    {
      title: 'Wprowadź dane',
      subtitle: 'Wprowadź opłatę ręcznie',
      icon: 'keyboard',
      function: () => this.onGoToManual(),
      bgColor: '#EDE4F4',
      bgHoverColor: '#DFD0EB'
    },

  ];


  constructor(
    private appConfig: AppConfig,
    private route: ActivatedRoute,
    private router: Router,
    private toolbar: ToolbarService,
    public handsetService: HandsetService,
  ) {
    this.toolbar.init(this.route);
    if (this.appConfig.config?.topUp?.visible) {
      this.buttons.push(
        {
          title: 'Doładuj telefon',
          subtitle: 'Zasil swój rachunek komórkowy',
          icon: 'mobile_friendly_24',
          function: () => this.onGotToTopUp(),
          disabled: !this.appConfig.config?.topUp?.enabled,
          bgColor: '#FAF8FC',
          bgHoverColor: '#EDE4F4'
        },
      );
    }
  }

  ngOnInit(): void {
    console.log(this.buttons);
    // todo odkomentowac
    // this.buttons[4].disabled =  !this.appConfig.config.topUp.visible;
  }

  private onGoToManual() {
    this.router.navigate(['manual'], { relativeTo: this.route });
  }

  private onGoToScan() {
    this.router.navigate(['scan'], { relativeTo: this.route });
  }

  private onGoToEbok() {
    this.router.navigate(['billers', 'add', 'ebok']);
  }

  private onGotToTopUp() {
    this.router.navigate(['top-up'], { relativeTo: this.route });
  }

  private onGotoMailSending() {
    this.router.navigate(['email'], { relativeTo: this.route });
  }

  protected readonly HandsetService = HandsetService;
}
